<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-01 17:41:20
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-07-08 15:26:59
 * @FilePath: /content-center/src/components/wiki/paragraphList.vue
-->
<template>
  <div>
    <div
      class="content-item flex textArea-flex"
      style="position: relative"
      v-for="(item, index) in paragraphList"
      :key="index"
    >
      <div class="content-item-label">
        <span v-if="JSON.parse(commonData[0].value) === '1'" class="red">*</span
        >{{ item.name }}
      </div>
      <c-editor
        v-if="item.style === 1"
        :content="item.content || ''"
        :index="index"
        @editorReady="editorReady"
        :ref="'editor' + index"
        @blurEditorEvent="blurEditorEvent"
      >
      </c-editor>
      <el-input
        v-if="item.style === 2"
        show-word-limit
        type="textarea"
        maxlength="100"
        v-model="item.content"
        :placeholder="`请输入${item.name}`"
        @input="editorChange(item.content, index)"
        :ref="'editor' + index"
      ></el-input>
    </div>
  </div>
</template>

<script>
import CEditor from "@/components/editor/CEditor";

export default {
  name: "paragraph",
  props: [
    "paragraphList",
    "blurEditorEvent",
    "editorReady",
    "editorChange",
    "commonData",
  ],
  data() {
    return {
      inputValue: "",
      keywordInfos: [],
    };
  },
  components: {
    CEditor,
  },
  created() {},
  watch: {
    paragraphList(newVal, oldVal) {},
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
//关键词
.keyword-list {
  width: 645px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .el-tag {
    margin-top: 5px;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;

    .el-tag__close {
      color: #909399;

      &:hover {
        background-color: #f4f4f5;
      }
    }
  }

  .input-keyword {
    border: none;
    flex-shrink: 0;
    width: 315px !important;

    :deep(.el-input__inner) {
      border: none !important;
      line-height: 26px;
      height: 26px;
    }
  }
}
</style>
